<template>
  <div style="overflow-x: auto; width: 100%;">
    <div style="min-width: 600px; padding: 5px;">
      <Scatter
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
  </div>
</template>

<script>
import { Scatter } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  PointElement,
  LineElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineController,
  ScatterController
} from "chart.js";

ChartJS.register(
  PointElement,
  LineElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineController,
  ScatterController,
  ChartDataLabels
);

export default {
  name: "ScatterChart",
  components: {
    Scatter
  },
  props: {
    chartId: {
      type: String,
      default: "scatter-chart"
    },
    datasetIdKey: {
      type: String,
      default: "label"
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: "",
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    },
    labels: {
      type: Array,
      default: () => []
    },
    datasets: {
      type: Array,
      default: () => []
    },
    scales: {
      type: Object,
      default: () => ({
        x: {
          type: "linear",
          position: "bottom"
        },
        y: {
          type: "linear",
          position: "left"
        }
      })
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {},
        scales: {},
        datalabels: {}
      })
    }

  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets
      },
     
    };
  },
};
</script>
